import { render } from "./InventoryTrendReport.vue?vue&type=template&id=170d5009&scoped=true"
import script from "./InventoryTrendReport.vue?vue&type=script&lang=js"
export * from "./InventoryTrendReport.vue?vue&type=script&lang=js"

import "./InventoryTrendReport.vue?vue&type=style&index=0&id=170d5009&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170d5009"]])

export default __exports__